import { Component, Input, Output, EventEmitter, inject, OnInit} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NZ_MODAL_DATA, NzModalRef } from "ng-zorro-antd/modal";
import { EventManager } from "src/app/core";
import { Constant } from "src/app/core/constant";
import { ModalComponent } from "../modal.component";
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
  selector: 'confirm-popup',
  templateUrl: "./confirm-popup.component.html",
  styleUrls: ["./confirm-popup.component.scss"]
})

export class ConfirmPopUpComponent extends ModalComponent implements OnInit {
    @Input('properties') properties;
    @Input('header') header;
    @Input('title') title;
    @Input('buttonLabel') buttonLabel;
    @Input('buttonCancelLabel') buttonCancelLabel;
    @Input() eventBroadcast;
    @Output() result: EventEmitter<any> = new EventEmitter();
    Constant = Constant;
    @Input() func: any;
    cancelFunc: any;
    config: any = {};
    readonly nzModalData: any = inject(NZ_MODAL_DATA);
    constructor(
        public eventManger: EventManager,
        private modalRef : NzModalRef,
        public translateService: TranslateService,
    ) {
        super(eventManger);
    }
    ngOnInit() {
        super.ngOnInit();
        this.header = this.nzModalData.header;
        this.title = this.nzModalData.title;
        this.buttonLabel = this.nzModalData.buttonLabel || this.translateService.instant('Xác nhận ');
        this.buttonCancelLabel = this.nzModalData.buttonCancelLabel || this.translateService.instant('Hủy bỏ');
        this.func = this.nzModalData.func;
        this.eventBroadcast = this.nzModalData.eventBroadcast;
        this.properties = this.nzModalData.properties;
        if (this.properties) {
            this.setData(this.properties);
        }
    }
    setData(data) {
        this.header = data.header;
        this.title = data.title;
        this.config = data.config || {};
        this.buttonLabel = data.buttonLabel || this.translateService.instant('Xác nhận ');
        this.buttonCancelLabel = data.buttonCancelLabel || this.translateService.instant('Hủy bỏ');
        this.func = data.func;
        this.cancelFunc = data.cancelFunc;
    }
    argree() {
        this.modalRef.close();
        if (this.func) {
            this.func();
        } else this.result.emit(true);
    }
    cancel() {
          this.modalRef.close();
        if (this.cancelFunc) {
            this.cancelFunc();
        } else this.result.emit(false) 
    }
    dismiss() {
          this.modalRef.close();
        this.result.emit(false);
    }
}
